module.exports = __webpack_public_path__ + "img/Badge.09d9cff4.svg";